import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2025-11-30',
  before_send: (event: any) => {
    const storedPersonProperties = event?.properties?.$stored_person_properties;
    if (storedPersonProperties && typeof storedPersonProperties === 'object') {
      delete storedPersonProperties.email;
      delete storedPersonProperties.name;
      delete storedPersonProperties.firstName;
      delete storedPersonProperties.lastName;
      delete storedPersonProperties.company;
    }
    return event;
  },
} as const;

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY as string}
      options={posthogOptions}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>,
);

// Performance measuring (optional)
reportWebVitals();
